module.exports = __webpack_public_path__ + "static/media/out-of-stock.2aab53b7.png";